import React from 'react';

import { useGetOne, useRecordContext } from 'react-admin';

import { Ping } from '../../../utilities/schemas/ping';
import { Rule } from '../../../utilities/schemas/rules';

import mapRuleNameToPingDetailsCard from './mapRuleNameToPingDetailsCard';

const PingDetailsCard = () => {
  const ping = useRecordContext<Ping>();

  const { data: rule } = useGetOne<Rule>('rules', { id: `${ping?.rule}` }, { enabled: !!ping?.rule });

  const DetailsCard = rule?.name ? mapRuleNameToPingDetailsCard[rule.name] : null;

  if (!DetailsCard) return null;

  return <DetailsCard />;
};

export default PingDetailsCard;
